"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORT = exports.RETIREMENT = exports.OUTSIDE_CONTRIBUTOR = exports.OTHER = exports.RESIDUALS_ROYALTIES = exports.INVESTMENT = exports.GOVERNMENT = exports.EMPLOYEE = exports.BUSINESS = void 0;
var BUSINESS = 'business';
exports.BUSINESS = BUSINESS;
var EMPLOYEE = 'employee'; // From: EMPLOYMENT

exports.EMPLOYEE = EMPLOYEE;
var GOVERNMENT = 'government';
exports.GOVERNMENT = GOVERNMENT;
var INVESTMENT = 'investment';
exports.INVESTMENT = INVESTMENT;
var RESIDUALS_ROYALTIES = 'residualsRoyalties';
exports.RESIDUALS_ROYALTIES = RESIDUALS_ROYALTIES;
var OTHER = 'other';
exports.OTHER = OTHER;
var OUTSIDE_CONTRIBUTOR = 'outsideContributor';
exports.OUTSIDE_CONTRIBUTOR = OUTSIDE_CONTRIBUTOR;
var RETIREMENT = 'retirement';
exports.RETIREMENT = RETIREMENT;
var SUPPORT = 'support';
exports.SUPPORT = SUPPORT;